/**
 * Labstep
 *
 * @module core/Ref
 * @desc Wrapper around semantic-ui-react Ref
 */

import React from 'react';
import { type RefProps, Ref as SemanticRef } from 'semantic-ui-react';

export const Ref = (props: RefProps) => {
  return <SemanticRef {...props} />;
};

export const RefWrapper: RFC<{
  innerRef: any;
}> = ({ innerRef, children }) =>
  innerRef ? (
    <Ref innerRef={innerRef}>
      <div>{children}</div>
    </Ref>
  ) : (
    <div>{children}</div>
  );
